import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const EDKProblems = () => {
  const { t } = useTranslation();

  const problems = [
    {
      id: 'babies',
      icon: 'ri-moon-line',
      accentColor: 'from-orange-500/20 to-red-900/10',
      borderColor: 'border-orange-500/25',
      iconBg: 'bg-orange-900/40',
      iconColor: 'text-orange-400',
      tagBg: 'bg-orange-900/30 border-orange-500/30 text-orange-300',
      image: 'https://public.readdy.ai/ai/img_res/74e1d299bea191441036ff4c60d879af.jpg',
      tagKey: 'edk_prob1_tag',
      titleKey: 'edk_prob1_title',
      subKey: 'edk_prob1_sub',
      paragraphs: ['edk_prob1_p1', 'edk_prob1_p2', 'edk_prob1_p3'],
      symptoms: ['edk_prob1_s1', 'edk_prob1_s2', 'edk_prob1_s3', 'edk_prob1_s4'],
    },
    {
      id: 'ruimte',
      icon: 'ri-home-4-line',
      accentColor: 'from-red-800/20 to-orange-900/10',
      borderColor: 'border-red-500/25',
      iconBg: 'bg-red-900/40',
      iconColor: 'text-red-400',
      tagBg: 'bg-red-900/30 border-red-500/30 text-red-300',
      image: 'https://readdy.ai/api/search-image?query=person%20entering%20dark%20empty%20new%20house%20doorway%20threshold%20dramatic%20dark%20atmospheric%20fog%20mist%20mysterious%20dark%20interior%20dark%20hallway%20new%20business%20empty%20space%20dramatic%20moody%20shadows%20spiritual%20cleansing%20entering%20threshold%20negative%20energy%20residual%20cinematic%20atmospheric&width=700&height=500&seq=edknew1&orientation=landscape',
      tagKey: 'edk_prob2_tag',
      titleKey: 'edk_prob2_title',
      subKey: 'edk_prob2_sub',
      paragraphs: ['edk_prob2_p1', 'edk_prob2_p2', 'edk_prob2_p3'],
      symptoms: ['edk_prob2_s1', 'edk_prob2_s2', 'edk_prob2_s3', 'edk_prob2_s4'],
    },
    {
      id: 'aanwezigheid',
      icon: 'ri-ghost-line',
      accentColor: 'from-red-950/30 to-orange-950/20',
      borderColor: 'border-red-600/20',
      iconBg: 'bg-red-950/50',
      iconColor: 'text-red-500',
      tagBg: 'bg-red-950/40 border-red-600/25 text-red-300',
      image: 'https://readdy.ai/api/search-image?query=adult%20person%20standing%20in%20dark%20hallway%20sensing%20unseen%20presence%20looking%20behind%20dark%20shadow%20entity%20atmospheric%20supernatural%20dark%20moody%20horror%20dramatic%20shadows%20mysterious%20dark%20corridor%20eerie%20atmospheric%20cinematic%20spiritual%20presence%20entity%20paranormal&width=700&height=500&seq=edkentity1&orientation=landscape',
      tagKey: 'edk_prob3_tag',
      titleKey: 'edk_prob3_title',
      subKey: 'edk_prob3_sub',
      paragraphs: ['edk_prob3_p1', 'edk_prob3_p2', 'edk_prob3_p3'],
      symptoms: ['edk_prob3_s1', 'edk_prob3_s2', 'edk_prob3_s3', 'edk_prob3_s4'],
    },
  ];

  return (
    <section id="problemen" className="w-full py-24 bg-[#080000]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-orange-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('edk_prob_badge')}</p>
          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            {t('edk_prob_title')}{' '}
            <span className="text-transparent bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text">
              {t('edk_prob_title2')}
            </span>
          </h2>
          <p className="text-white/40 text-sm max-w-xl mx-auto leading-relaxed">
            {t('edk_prob_sub')}
          </p>
        </div>

        <div className="space-y-20">
          {problems.map((p, idx) => (
            <div
              key={p.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${
                idx % 2 === 1 ? 'lg:[direction:rtl]' : ''
              }`}
            >
              {/* Image side */}
              <div className={`relative rounded-3xl overflow-hidden border ${p.borderColor} ${idx % 2 === 1 ? '[direction:ltr]' : ''}`}>
                <div className="h-72 lg:h-96">
                  <img
                    src={p.image}
                    alt={t(p.titleKey)}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080000]/80 via-[#080000]/20 to-transparent" />
                </div>
                <div className="absolute top-4 left-4">
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold backdrop-blur-sm ${p.tagBg}`}>
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className={`${p.icon} text-xs`} />
                    </div>
                    {t(p.tagKey)}
                  </span>
                </div>
              </div>

              {/* Content side */}
              <div className={idx % 2 === 1 ? '[direction:ltr]' : ''}>
                <div className="flex items-center gap-4 mb-5">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-2xl border ${p.borderColor} ${p.iconBg}`}>
                    <i className={`${p.icon} text-xl ${p.iconColor}`} />
                  </div>
                  <span className="text-white/15 font-black text-5xl leading-none">{String(idx + 1).padStart(2, '0')}</span>
                </div>

                <h3 className="text-2xl lg:text-3xl font-black text-white mb-2">{t(p.titleKey)}</h3>
                <p className={`text-sm mb-6 font-medium ${p.iconColor}`}>{t(p.subKey)}</p>

                <div className="space-y-4 mb-8">
                  {p.paragraphs.map((key) => (
                    <p key={key} className="text-white/55 text-sm leading-relaxed">{t(key)}</p>
                  ))}
                </div>

                {/* Symptoms */}
                <div className={`bg-gradient-to-br ${p.accentColor} border ${p.borderColor} rounded-2xl p-5 mb-8`}>
                  <p className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-3">{t('edk_prob_symptoms_label')}</p>
                  <ul className="space-y-2">
                    {p.symptoms.map(key => (
                      <li key={key} className="flex items-start gap-2.5">
                        <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                          <i className={`ri-checkbox-circle-line text-sm ${p.iconColor}`} />
                        </div>
                        <span className="text-white/65 text-sm leading-relaxed">{t(key)}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Link
                  to="/shop?cat=evil-energy-destroy-kit"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-600 to-red-700 text-white font-bold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shopping-bag-line text-sm" />
                  </div>
                  {t('edk_prob_order_btn')}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
